// extracted by mini-css-extract-plugin
export default {"main":"styles_main__Xjtl0","container":"styles_container__WIeUi","error":"styles_error__PqhHF","submit":"styles_submit__4f-sZ","no_account":"styles_no_account__MFWT4"};